exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".results-container[data-v-fe3a3e10]{margin-top:20px}p.no-results[data-v-fe3a3e10]{font-size:21px;color:grey;padding-top:40px}p.label[data-v-fe3a3e10]{color:gray;padding-bottom:10px}.field[data-v-fe3a3e10]{color:#2c8ada;font-size:15px}.name[data-v-fe3a3e10]{color:#2c8ada;font-size:21px}.related-card-bottom.middle[data-v-fe3a3e10]{border-bottom:1px solid #d3d3d3;padding-bottom:15px}.customer-card-bottom[data-v-fe3a3e10],.related-card-bottom[data-v-fe3a3e10]{padding-top:20px}.customer-card-top[data-v-fe3a3e10],.related-card-top[data-v-fe3a3e10]{padding-top:15px;padding-bottom:15px;border-bottom:1px solid #d3d3d3}@media (min-width:576px){.related-card-top .col-sm-1[data-v-fe3a3e10]{max-width:1.333333%!important}}.removeBottomBorder[data-v-fe3a3e10]{border-bottom:none!important;padding-bottom:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fe3a3e10","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/advancedSearchResult.vue
// module id = 768
// module chunks = 0